import { render, staticRenderFns } from "./BranchSemiology.vue?vue&type=template&id=1425fe43&scoped=true&"
import script from "./BranchSemiology.vue?vue&type=script&lang=js&"
export * from "./BranchSemiology.vue?vue&type=script&lang=js&"
import style0 from "./BranchSemiology.vue?vue&type=style&index=0&id=1425fe43&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1425fe43",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
